import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const videoRoutes: RouteRecordRaw[] = [
  {
    path: '/videos',
    name: 'videos',
    component: () => import('@/modules/videos/views/VideoListView.vue'),
    meta: {
      permission: PERMISSIONS.CONTENT.VIEW,
      projectScoped: true,
    },
  },
]
